import { render, staticRenderFns } from "./lsCollFromRcForm.vue?vue&type=template&id=ef673046&scoped=true&"
import script from "./lsCollFromRcForm.vue?vue&type=script&lang=js&"
export * from "./lsCollFromRcForm.vue?vue&type=script&lang=js&"
import style0 from "./lsCollFromRcForm.vue?vue&type=style&index=0&id=ef673046&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef673046",
  null
  
)

export default component.exports